import axios from 'axios'
import { stringify } from 'query-string'
import {
  BudgetRevisionsResponse,
  GetBudgetRevisionsQueryParams,
} from 'src/queries/creditCards/budgetRevisions/budgetRevisions.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

// Replaces the getBudgetRevisions thunk in
// src/redux/actions/data/budgetRevisions.actions.ts, which used
// selectAuthedJsonApiRequestConfig -> RequestConfig.Default here.
export const getBudgetRevisions = async (
  creditCardId: string,
  queryParams: GetBudgetRevisionsQueryParams = {},
): Promise<BudgetRevisionsResponse> => {
  const qs = stringify(queryParams)

  return getResponseData(
    axios.get<BudgetRevisionsResponse>(
      `/creditcards/${creditCardId}/revisions${qs ? `?${qs}` : ''}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
